export enum ShowCards {
  EVERYONE = "EVERYONE",
  OWNER = "OWNER",
}

export type ShowCardsOption = {
  label: string;
  value: ShowCards;
};

export const ShowCardsOptions: ShowCardsOption[] = [
  {
    value: ShowCards.EVERYONE,
    label: "Everyone",
  },
  {
    value: ShowCards.OWNER,
    label: "Owner",
  },
];
